import { render, staticRenderFns } from "./EditLinkDeals.vue?vue&type=template&id=622a82ad&scoped=true&"
import script from "./EditLinkDeals.vue?vue&type=script&lang=js&"
export * from "./EditLinkDeals.vue?vue&type=script&lang=js&"
import style0 from "./EditLinkDeals.vue?vue&type=style&index=0&id=622a82ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a82ad",
  null
  
)

export default component.exports